import calculationMenuApi from '@/api/calculation-menu'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  fetchData(context, attributes = {}) {
    return calculationMenuApi.getCalculationMenuData({ params: attributes })
  },
  exportExcel(context, attributes = {}) {
    return calculationMenuApi.exportCalculationMenuExcel(attributes)
  },
  saveManual(context, attributes = {}) {
    return calculationMenuApi.saveCalculationMenuManual(attributes)
  },
  calculate(context, attributes = {}) {
    return calculationMenuApi.calculateHeadcount(attributes)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
